import React from 'react';

const PlusButtonGrey = () => (
  <svg
    width="78px"
    height="78px"
    viewBox="0 0 78 78"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Plus Button grey</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="Desktop"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Cart-First-Time-User"
        transform="translate(-853.000000, -421.000000)"
        stroke="#979797"
      >
        <g id="Group-14" transform="translate(730.000000, 376.000000)">
          <g id="Plus-Button-grey" transform="translate(125.000000, 47.000000)">
            <circle id="Oval" strokeWidth="2.75" cx="37" cy="37" r="37" />
            <g
              id="Group-7"
              transform="translate(22.000000, 20.000000)"
              strokeWidth="3"
              strokeLinecap="square"
            >
              <path d="M15.5,0.566666667 L15.5,33.4333333" id="Line" />
              <path d="M31,16.5 L0,16.5" id="Line" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PlusButtonGrey;



// WEBPACK FOOTER //
// ./src/assets/PlusButtonGrey.jsx